export default __webpack_public_path__ + "static/media/493.742282e8.png";